import { checkUser } from "./checkUser";
import { forgotPassword } from "./forgotPassword";
import { newPassword } from "./newPassword";
import { recoveryCode } from "./recoveryCode";
import { register } from "./register";
import { signin } from "./signIn";

export const authService = {
  signin,
  register,
  forgotPassword,
  recoveryCode,
  newPassword,
  checkUser,
};
